import { createMuiTheme } from '@material-ui/core/styles';

export default createMuiTheme({
	palette: {
		primary: {
		    light: '#659FFC',
		    main: '#4D88FF',
		    dark: '#457FDD'
		  },
		  secondary : {
			main: '#595959',
		  },
		  light : {
		  	main: '#ffffff',
		  }
		  // secondary: {
		  //   light: '#ffffff',
		  //   main: '#ffffff',
		  //   dark: '#ffffff',
		  //   contrastText: '#ffffff',
		  // },
	},
})


// WEBPACK FOOTER //
// ./src/theme.js